import { ReactNode } from 'react';

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import { dateToFrontEndFormat } from 'common/utils/dateHelpers';
import { ReportCustomTableColumn, ReportCustomTableRow } from 'features/reports/typeDefs';

export type ReportCustomTableProps = {
  columns: ReportCustomTableColumn[];
  rows: ReportCustomTableRow[];
  tableCaption: string;
  countMessage: string;
  dataTestId?: string;
}

export const ReportCustomTable = ({ columns, rows, tableCaption, countMessage, dataTestId }: ReportCustomTableProps) => {
    return (
        <TableContainer className='print-table-content' sx={{ marginBottom: '25px' }}>
            <Table
                sx={{ minWidth: 650 }}
                aria-label="simple table"
                data-testid={dataTestId}
            >
                <TableHead>
                    <TableRow>
                        <TableCell align="left" colSpan={3}>
                            <Typography
                                variant='h6'
                                color='primary.accent'
                            >
                                {tableCaption}
                            </Typography>
                        </TableCell>
                        <TableCell align="right" colSpan={3}>
                            <Typography
                                variant='subtitle1'
                                color='text.secondary'
                            >
                                {countMessage}
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align ? column.align : 'left'}
                                sx={{
                                    minWidth: column.minWidth ? column.minWidth : 150,
                                    fontWeight: 'bold',
                                    backgroundColor: 'info.main'
                                }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => {
                        return (
                            <TableRow
                                hover
                                key={row?.id as string}
                            >
                                {columns.map((column) => {
                                    let value = row[column.id] as ReactNode;
                                    if (column.id === 'startDate' || column.id === 'endDate'){
                                        value = dateToFrontEndFormat(row[column.id] as string) as ReactNode ;
                                    }
                                    return (
                                        <TableCell key={column.id} align={column.align ? column.align : 'left'}>
                                            {value}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
